const defaultTitle = `weall`;
module.exports = {
  defaultTitle,
  titles: {
    auth: {
      login: `${defaultTitle} | LogIn`,
      forgotPassword: `${defaultTitle} | Forgot Password`,
      otpVerification: `${defaultTitle} | OTP Verifcation`,
      resetPassword: `${defaultTitle} | Reset Password`,
      mfaVerification: `${defaultTitle} | MFA Verification`,
      googleMFAVerification: `${defaultTitle} | Google Auth MFA Verification`,
      smsMFAVerification: `${defaultTitle} | SMS Auth MFA Verification`,
    },
    dashboard: `${defaultTitle} | Dashboard`,
    edit_profile: `${defaultTitle} | Edit Profile`,
    change_password: `${defaultTitle} | Change Password`,
    masters: {
      translations: `${defaultTitle} | Translations`,
      addTranslation: `${defaultTitle} | Add Translation`,
      editTranslation: `${defaultTitle} | Edit Translation`,
      cms: {
        list: `${defaultTitle} | CMS`,
        addCMS: `${defaultTitle} | Add CMS`,
        editCMS: `${defaultTitle} | Edit CMS`,
      },
      emailTemplate: {
        list: `${defaultTitle} | Email Templates`,
        add: `${defaultTitle} | Add Email Templates`,
        edit: `${defaultTitle} | Edit Email Templates`,
      },
      smsTemplate: {
        list: `${defaultTitle} | SMS Templates`,
        add: `${defaultTitle} | Add SMS Templates`,
        edit: `${defaultTitle} | Edit SMS Templates`,
      },
      cancelReason: {
        list: `${defaultTitle} | Cancel Reasons`,
        add: `${defaultTitle} | Add Reason`,
        edit: `${defaultTitle} | Edit Reason`,
      },
    },
    settings: {
      generalSettings: `${defaultTitle} | General Settings`,
      subAdmin: {
        list: `${defaultTitle} | Sub Admin List`,
        add: `${defaultTitle} | Add Sub Admin`,
        edit: `${defaultTitle} | Edit Sub Admin`,
        view: `${defaultTitle} | View Sub Admin`,
      },
    },
    userMaster: {
      view: `${defaultTitle}| User Details`,
      list: `${defaultTitle} | User Master`,
      edit: `${defaultTitle} | Edit User`,
      transactions: `${defaultTitle} | User Transactions`,
      balance: `${defaultTitle} | User Balance`,
      featureConfiguration: `${defaultTitle} | User Feature Configuration`,
    },
    dummyUser: {
      list: `${defaultTitle} | Dummy Users`,
      add: `${defaultTitle} | Add Dummy User`,
      edit: `${defaultTitle} | Edit Dummy User`,
      view: `${defaultTitle} | Dummy User Details`,
    },
    freelancerUser: {
      list: `${defaultTitle} | Freelancer Users`,
      view: `${defaultTitle} | Freelancer User Details`,
      serviceView: `${defaultTitle} | Freelancer Service Details`,
    },
    review: {
      list: `${defaultTitle} | Reviews`,
      view: `${defaultTitle} | Review Details`,
    },
    notification: {
      list: `${defaultTitle} | Notifications`,
    },
  },
  otpTimeOut: 30,
  status: {
    active: "1",
    inActive: "0",
    // API status values
    apiStatus: {
      active: "active",
      inactive: "inactive",
      deactivated: "deactivated",
      deleted: "deleted",
      true: "true",
      false: "false"
    },
    // User status options for dropdowns
    userStatusOptions: [
      { value: "", label: "" }, // Will be translated
      { value: "active", label: "" }, // Will be translated
      { value: "inactive", label: "" }, // Will be translated
      { value: "deleted", label: "" } // Will be translated
    ],
    // Admin status options for dropdowns
    adminStatusOptions: [
      { value: "", label: "" }, // Will be translated
      { value: "deactivated", label: "" }, // Will be translated
      { value: "active", label: "" } // Will be translated
    ],
    // Reported user status filter options
    reportedUserStatusOptions: [
      { value: "", label: "admin.reported_users_list_user_status_all" },
      { value: "active", label: "admin.reported_users_list_user_status_active" },
      { value: "deactivated", label: "admin.reported_users_list_user_status_deactivated" },
    ],
    // "Reported Post and Stories" tab: filter by content type. value is what the backend's
    // feed_content_type query param expects ("" = both).
    reportedFeedContentTypeOptions: [
      { value: "", label: "admin.reported_users_list_content_type_all" },
      { value: "post", label: "admin.reported_users_list_content_type_post" },
      { value: "story", label: "admin.reported_users_list_content_type_story" },
    ],
    // Review rating filter options
    reviewRatingOptions: [
      { value: "", label: "admin.review_rating_filter_placeholder" },
      { value: "5", label: "5" },
      { value: "4", label: "4" },
      { value: "3", label: "3" },
      { value: "2", label: "2" },
      { value: "1", label: "1" },
    ],
    // Notification read/unread filter options
    notificationStatusOptions: [
      { value: "", label: "admin.notification_filter_all" },
      { value: "false", label: "admin.notification_filter_unread" },
      { value: "true", label: "admin.notification_filter_read" },
    ],
    // Signup type options
    signupTypeOptions: [
      { value: "", label: "" }, // Will be translated
      { value: "normal", label: "" }, // Will be translated
      { value: "google", label: "" }, // Will be translated
      { value: "apple", label: "" } // Will be translated
    ]
  },
  sort: {
    order: {
      asc: "asc",
      desc: "desc"
    }
  },
  dateTypes: {
    start: "start",
    end: "end"
  },
  mfa_types: {
    google_auth: "1",
    sms_auth: "2",
  },
  userTabs: {
    PERSONAL: 'personal',
    PROFILE: 'profile',
    EDUCATION: 'education',
    WORK: 'work',
    INTERESTS: 'interests',
  },
  dummyUserTabs: {
    PERSONAL: 'personal',
    PROFILE: 'profile',
    EDUCATION: 'education',
    WORK: 'work',
    INTERESTS: 'interests',
  },
  encryptedStatus: {
    active: [
      '7d35e9a23b50107500c0cf127175bd40',
      'a829e73e160c5d7d36fec90754f2f7ab',
      'a3c6d0cbe7085162c7425d2c10f0fbd6',
    ],
    inactive: [
      'c233c4da9933eec631c01b2255656e1d',
    ],
  },
  validation: {
    settings: {
      supportedImageFormats: ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml', 'image/x-icon', 'image/vnd.microsoft.icon'],
      versionRegex: /^[0-9.]+$/,
      maxVersionLength: 30,
    },
    adminRewardsSettings: {
      premiumGrantMonthsMin: 1,
    },
    referralSettings: {
      milestoneSizeMin: 1,
      milestoneSizeMax: 100,
      monthsPerMilestoneMin: 1,
      monthsPerMilestoneMax: 12,
      // Login streak is tracked as a bitmask on a 32-bit Int column on the backend -
      // must never be allowed to exceed this, see constants/setting.constant.js#REFERRAL_MAX_CONSECUTIVE_DAYS.
      consecutiveDaysMin: 1,
      consecutiveDaysMax: 28,
      minMessagesMin: 0,
      minMessagesMax: 50,
    },
    userMaster: {
      deactivateReason: {
        minLength: 5,
        maxLength: 500,
      },
    },
  },
  formFields: {
    generalSettings: {
      headerLogo: "home_page_general_header_logo",
      faviconLogo: "home_page_general_favicon_logo", 
      loginPageLogo: "home_page_general_login_page_logo",
      emailLogo: "home_page_general_email_logo",
      iosVersion: "setting_ios_app_version",
      androidVersion: "setting_android_app_version",
      contactEmail: "admin_contact_email",
    },
    adminRewardsSettings: {
      premiumGrantMonths: "premium_grant_months",
      premiumAutoGrantOnSignup: "premium_auto_grant_on_signup",
    },
    referralSettings: {
      milestoneSize: "referral_milestone_size",
      monthsPerMilestone: "referral_months_per_milestone",
      consecutiveDaysRequired: "referral_consecutive_days_required",
      minMessagesRequired: "referral_min_messages_required",
    },
    cms: {
      slug: "slug",
      isActive: "is_active",
      translations: "translations",
      title: "title",
      description: "description",
      seoMetaTitle: "seo_meta_title",
      seoMetaDesc: "seo_meta_desc",
    },
    emailTemplate: {
      slug: "slug",
      parameter: "parameter",
      emailTemplates: "email_templates",
      title: "title",
      subject: "subject",
      content: "content",
      searchText: "searchText",
    },
    smsTemplate: {
      slug: "slug",
      parameter: "parameter",
      smsTemplates: "sms_templates",
      title: "title",
      content: "content",
      searchText: "searchText",
    },
  },
  fileFormats: {
    images: ".jpeg,.jpg,.png,.svg,.ico",
  },
  inputTypes: {
    text: "text",
    email: "email",
    file: "file",
    password: "password",
    textarea: "textarea",
    select: "select",
    phone: "phone",
    submit: "submit",
  },
  dataTypes: {
    object: "object",
    array: "array",
    string: "string",
    number: "number",
    boolean: "boolean",
  },
  pagination: {
    defaultPageSize: 10,
    defaultPage: 1,
  },
  dummyUser: {
    // System-defined default password for all dummy users, shown read-only on the add form.
    defaultPassword: "Weall@123456",
  },
  // Subscription plan user type values (must match the backend's userType enum exactly)
  userType: {
    normalUser: "normal_user",
    freelancerUser: "freelancer_user",
  },
  // Subscription plan duration picker values (must match the backend's
  // SUBSCRIPTION_PLAN_DURATION_VALUES exactly - see constants/premium.constant.js)
  subscriptionPlanDuration: {
    weekly: "weekly",
    monthly: "monthly",
    quarterly: "quarterly",
    semiannually: "semiannually",
    annually: "annually",
  },
  // Navigation path patterns
  navigation: {
    userViewPattern: '/user/',
    viewPathKeyword: '/view',
    masterPattern: '/masters/',
    translationPattern: '/masters/translation/',
    emailTemplatePattern: '/masters/email-templates/',
    cmsPattern: '/masters/cms/',
    smsTemplatePattern: '/masters/sms-templates/',
    reportedUsersPattern: '/masters/reported-users/',
    serviceCategoryPattern: '/masters/service-categories/',
    subscriptionPlanPattern: '/masters/subscription-plans/',
    subscribedUserPattern: '/masters/subscribed-users/',
    referralRecordPattern: '/masters/referral-records/',
    communityLeaderboardPattern: '/masters/community-leaderboard/',
    dummyUserPattern: '/user/dummy/',
    freelancerUserPattern: '/user/freelancer/',
    reviewPattern: '/reviews/',
  },
  // Index constants for dropdown options
  optionIndexes: {
    DEFAULT: 0,
    ADMIN_INACTIVE: 1,
    ADMIN_ACTIVE: 2,
    USER_ACTIVE: 1,
    USER_INACTIVE: 2,
    USER_DELETED: 3,
    SIGNUP_NORMAL: 1,
    SIGNUP_GOOGLE: 2,
    SIGNUP_APPLE: 3,
  },
  // Phone number constants
  phone: {
    maxCharacters: 16, // +49 + 13 digits = 16 total
    countryCode: '+49',
    placeholder: '+49 0123456789012',
  },
  storageKeys: {
    adminEmailTemplateTable: "adminEmailTemplateTable",
    adminSmsTemplateTable: "adminSmsTemplateTable",
  },
  defaultLanguage: "english",
  // Share redirect constants (profile, community, group)
  shareRedirect: {
    types: {
      profile: {
        redirectPath: "/mobile/dashboard/share-app-redirect-url",
        deepLinkParams: {},
      },
      community: {
        redirectPath: "/mobile/community/share-community-redirect-url",
        deepLinkParams: { share_community: "true" },
      },
      group: {
        redirectPath: "/mobile/group/share-group-redirect-url",
        deepLinkParams: { share_group: "true" },
      },
    },
    errors: {
      tokenRequired: "Token is required",
      tokenValidationFailed: "Failed to validate token. Please try again.",
      invalidShareType: "Invalid share type.",
      loadFailed: "Unable to load the shared content. Please try again.",
    },
    timeouts: {
      deepLinkAttempt: 100,
      deepLinkCheck: 2000,
      deepLinkTimeout: 2500,
      cleanupDelay: 3000,
    },
  },
  // @deprecated — use shareRedirect
  shareWeAll: {
    errors: {
      tokenRequired: "Token is required",
      tokenValidationFailed: "Failed to validate token. Please try again.",
    },
    timeouts: {
      deepLinkAttempt: 100,
      deepLinkCheck: 2000,
      deepLinkTimeout: 2500,
      cleanupDelay: 3000,
    },
  },
};
